import loanFormModel, {
  taxDocuments,
} from '../../components/loan_application/form_models/loanFormModel';
import { defaultApplicantName } from '../../constants';
import { ValidationSchema } from '../interfaces';
import FileNameValidationSchema from '../FileNameValidationSchema';
import { Validation } from '../Validation';

const { financialStatementQ2 } = taxDocuments;

const { systemPowerUsage, isPG } = loanFormModel.formField;

export class FinancialStatementQ2Validation implements ValidationSchema {
  public name = financialStatementQ2.name;
  public label = financialStatementQ2.getLabel(defaultApplicantName);
  public dependsOn: string[] = [isPG.name, systemPowerUsage.name];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  public when(isPersonalGuarantor, systemPowerUsage, schema) {
    const required =
      financialStatementQ2.displayCondition(isPersonalGuarantor) &&
      financialStatementQ2.getRequired(systemPowerUsage);
    return FileNameValidationSchema(financialStatementQ2.name, required);
  }
}
export default new Validation(new FinancialStatementQ2Validation());
